import { BaseModel } from "./base.model";
import { Budget, BudgetInclWeightedPipeline } from "./budget.model";

export class Department extends BaseModel {

constructor(
    public name?: string,
    public includedInDashboard?: boolean,
) {
    super();
    
}
}